import { createStore } from "vuex";
import { config } from "vuex-module-decorators";
import VuexPersistence from "vuex-persist";

import UserAuthModule from "@/store/modules/common/UserAuthModule";
import BodyModule from "@/store/modules/common/BodyModule";
import BreadcrumbsModule from "@/store/modules/common/BreadcrumbsModule";
import ConfigModule from "@/store/modules/common/ConfigModule";
import WebSocketModule from "@/store/modules/common/WebSocketModule";
import UserSettingsModule from "@/store/modules/common/UserSettingsModule";
import TwoFactorAuthModule from "@/store/modules/common/TwoFactorAuthModule";
import TicketsModule from "@/store/modules/manager/TicketsModule";
import NotificationsModule from "@/store/modules/manager/NotificationsModule";
import CompanyAccountsModule from "@/store/modules/manager/CompanyAccountsModule";
import StatisticModule from "@/store/modules/admin/StatisticModule";
import ActivityLogsModule from "@/store/modules/common/ActivityLogsModule";
import UsersModule from "@/store/modules/admin/UsersModule";
import AuthCheckpointsModule from "@/store/modules/admin/AuthCheckpointsModule";
import CompaniesModule from "@/store/modules/admin/CompaniesModule";
import AccountsModule from "@/store/modules/admin/AccountsModule";
import IntegritiesModule from "@/store/modules/admin/IntegritiesModule";
import BootstrapModule from "@/store/modules/common/BootstrapModule";
import SystemOverviewModule from "@/store/modules/admin/SystemOverviewModule";
import CompanyStatisticModule from "@/store/modules/manager/CompanyStatisticModule";
import DictionaryModule from "@/store/modules/common/DictionaryModule";
import ComplianceTrackingsModule from "@/store/modules/manager/ComplianceTrackingsModule";
import ManagerAnnouncementModule from "@/store/modules/manager/AnnouncementsModule";
import AdminAnnouncementModule from "@/store/modules/admin/AnnouncementsModule";
import AffiliateCompaniesModule from "@/store/modules/manager/AffiliateCompaniesModule";
import CompanyProductsModule from "@/store/modules/manager/CompanyProductsModule";
import PortalServiceModule from "@/store/modules/manager/PortalServiceModule";
import WalletsModule from "@/store/modules/manager/WalletsModule";
import ExchangeRatesModule from "@/store/modules/manager/ExchangeRatesModule";
import MenuModule from "@/store/modules/common/MenuModule";
import ApiRequestsStatsModule from "@/store/modules/common/ApiRequestsStatsModule";
import FlexpspModule from "@/store/modules/manager/FlexpspModule";
import WhiteLabelModule from "@/store/modules/manager/WhiteLabelModule";
import WhiteLabelChildrenModule from "@/store/modules/manager/WhiteLabelChildrenModule";
import SettingsModule from "@/store/modules/admin/SettingsModule";
import ZohoAppModule from "@/store/modules/common/ZohoAppModule";
import TimelineModule from "@/store/modules/admin/TimelineModule";

export const vuexKey = "banking";

const vuexStorage = new VuexPersistence({
  storage: window.localStorage,
  key: vuexKey,
  modules: [
    "DictionaryModule",
    "NotificationsModule",
    "AccountsModule",
    "StatisticModule",
    "ActivityLogsModule",
    "UsersModule",
    "AuthCheckpointsModule",
    "CompaniesModule",
    "CompanyAccountsModule",
    "CompanyStatisticModule",
    "ManagerAnnouncementModule",
    "AffiliateCompaniesModule",
    "ApiRequestsStatsModule",
    "TimelineModule",
  ],
});

config.rawError = true;

const store = createStore({
  plugins: [vuexStorage.plugin],
  modules: {
    UserAuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    WebSocketModule,
    UserSettingsModule,
    DictionaryModule,
    TwoFactorAuthModule,
    TicketsModule,
    NotificationsModule,
    AccountsModule,
    StatisticModule,
    ActivityLogsModule,
    UsersModule,
    AuthCheckpointsModule,
    CompaniesModule,
    CompanyAccountsModule,
    IntegritiesModule,
    BootstrapModule,
    SystemOverviewModule,
    CompanyStatisticModule,
    ManagerAnnouncementModule,
    AdminAnnouncementModule,
    ComplianceTrackingsModule,
    AffiliateCompaniesModule,
    WhiteLabelChildrenModule,
    CompanyProductsModule,
    PortalServiceModule,
    WalletsModule,
    ExchangeRatesModule,
    MenuModule,
    ApiRequestsStatsModule,
    FlexpspModule,
    WhiteLabelModule,
    SettingsModule,
    ZohoAppModule,
    TimelineModule,
  },
});

export default store;
